import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class StaffHeaderBrandingService {
  private readonly useCompactLogoSubject = new BehaviorSubject(false);
  private readonly programNameSubject = new BehaviorSubject('');

  readonly useCompactLogo$: Observable<boolean> = this.useCompactLogoSubject.asObservable();
  readonly programName$: Observable<string> = this.programNameSubject.asObservable();

  getUseCompactLogo(): boolean {
    return this.useCompactLogoSubject.value;
  }

  getProgramName(): string {
    return this.programNameSubject.value;
  }

  /** Match unified portal: icon + program name while on any /program route. */
  setProgramHeader(programName: string | null | undefined): void {
    const name = (programName ?? '').trim();
    this.useCompactLogoSubject.next(true);
    this.programNameSubject.next(name);
  }

  clear(): void {
    this.useCompactLogoSubject.next(false);
    this.programNameSubject.next('');
  }
}
